export async function getCaixaDAgua() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/getCaixasDagua`);
        if (!response.ok) {
            throw new Error(`Erro: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Erro ao buscar caixas d'água:", error);
        return [];
    }
  }
  